import React, { Component } from "react";
import { FlexContainer } from "src/components";
import styled from "styled-components";
import OphLogo from "../../img/new/me_business_logo.png";

const FullPageContainer = styled(FlexContainer)`
    min-height: 100vh;
    justify-content: center;
    align-items: center;
    background-color: #404df3;
`;

const MessageContainer = styled.div`
    text-align: center;
    color: #ffffff;
    font-weight: semi-bold;

    h1 {
        margin-bottom: 16px;
    }

    p {
        font-size: 20px;
    }
`;

const OphImage = styled.img`
    width: 250px;
    height: auto;
    margin: 1em;
    position:relative;
    top: 2px;
`;

const OphLink = styled.a`
    text-decoration: none;
`;

class Unsubscribe extends Component {
    render() {
        return (
            <FullPageContainer>
                <FlexContainer
                    alignItems="center"
                    justifyContent="center"
                    flexGrow="1"
                    style={{ height: "100vh" }}
                >
                    <OphLink href="https://www.mebusiness.com.au/" target="_blank" rel="noopener noreferrer">
                        <OphImage src={OphLogo} />
                    </OphLink>
                    <MessageContainer>
                        <h1>You have successfully unsubscribed</h1>
                        <p>You have been removed from our audience list and will no longer receive emails from us.</p>
                    </MessageContainer>
                </FlexContainer>
            </FullPageContainer>
        );
    }
}

export default Unsubscribe;
